var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2327,
    height: 617,
    viewBox: "0 0 2327 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 102.5L153.5 0H353L373 102.5L325 456L242 609.5H0L130.5 393.5L174.5 102.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M590 1.5H413L429.5 84.5H607L590 1.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M607 106.5H429.5L384 456H564L607 106.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M830.5 106.5H672L628 456H755.5L854.5 303.5C858.29 298.587 859.852 298.048 861 303.5V322.5L844.5 456H972L1077.5 291.5C1080.7 289.642 1082.33 289.666 1085 291.5L1064 456H1228L1266 106.5H1109.5L1045.5 201C1039.67 206.566 1037.53 206.3 1036 199L1048 106.5H907L822 231C819.107 234.09 816.895 234.509 816.5 231L830.5 106.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1486 106.5H1327.5L1283.5 456H1425L1585 285C1588.73 281.434 1589.97 281.141 1590 285L1570 456H1736.5L1775.5 106.5H1619.5L1479 255.5C1476.63 257.039 1475.37 257.372 1473.5 255.5L1486 106.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1987 112.5H1837.5L1801.5 459.5H1940.5L1847 616.5H2043L2326.5 112.5H2152L1997 362.5H1960L1987 112.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3005c404e3623273311247c6b72ab905.svg";
export { ForwardRef as ReactComponent };